<template>
		<div  class="taskstatus">
			<div class="electronic">
				<img class="backimg" src="../../assets/imgs/de252514.jpg">
				<div class="title_txt">新能智运平台运营端电子运单</div>
				<!-- 第一块区域 -->
				<div class="box1">
					<div class="table">
						<div class="table_row">
							<div class="table_td">
								车牌号码:
								<span class="txt">{{carEntity.plate|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								挂车号码:
								<span class="txt">{{carEntity.hangPlate|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								计划编号:
								<span class="txt">{{planEntity.pno|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_row">
								<div class="table_td">
									货类:
									<span class="txt">{{dispatchTruck.cargoname|formatMsgFun}}</span>
								</div>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								船名:
								<span class="txt">{{dispatchTruck.shipname|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								船次:
								<span class="txt">{{planEntity.shipflight|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								场地:
								<span class="txt">{{planEntity.stname|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								货位:
								<span class="txt">{{planEntity.hwstr|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_row">
								<div class="table_td">
									提单号:
									<span class="txt">{{planEntity.billofladingCode|formatMsgFun}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 第二块区域 -->
				<div class="box2">
					<div class="table">
						<div class="table_row">
							<div class="table_td">
								货主:
								<span class="txt">{{dispatchTruck.customname|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								毛重:
								<span class="txt">{{dispatchTruck.roughWeight|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								代理:
								<span class="txt">{{dispatchTruck.agentname|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								皮重:
								<span class="txt">{{dispatchTruck.tare|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								流向:
								<span class="txt">{{dispatchTruck.custmername|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								净重:
								<span class="txt">{{dispatchTruck.suttle|formatMsgFun}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								代理:
								<span class="txt">{{dispatchTruck.fleetname|formatMsgFun}}</span>
							</div>
							<div class="table_td">
								运费:
								<span class="txt">{{dispatchTruck.freightCharge|formatMsgFun}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 第三块区域 -->
				<div class="box3">
					<div class="table">
						<div class="table_row">
							<div class="table_td">
								预约时间:
								<span class="txt">{{dataFormat(dispatchTruck.ordertime,'long')}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								进场时间:
								<span class="txt">{{dataFormat(dispatchTruck.instoredate,'long')}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								出场时间:
								<span class="txt">{{dataFormat(dispatchTruck.outstoredate,'long')}}</span>
							</div>
						</div>
						<div class="table_row">
							<div class="table_td">
								合同编号:
								<span class="txt">{{planEntity.contractno|formatMsgFun}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="last_txt">
					运单编号: {{planEntity.id?planEntity.id:""}}
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		data() {
			return {
				planEntity: {},
				dispatchTruck: {},
				carEntity: {}
			}
		},
		mounted() {
			this.getmsginfo();
		},
		methods: {
			dataFormat(dt, long) {
				if (!dt) return "";
				let date = new Date(dt),
					yy = date.getFullYear(),
					mon = (date.getMonth() + 1 + '').padStart(2, 0),
					dd = (date.getDate() + '').padStart(2, 0),
					hh = (date.getHours() + '').padStart(2, 0),
					mm = (date.getMinutes() + '').padStart(2, 0),
					s = (date.getSeconds() + '').padStart(2, 0);
				if (long) return `${yy}-${mon}-${dd} ${hh}:${mm}:${s}`
				return `${yy}-${mon}-${dd}`
			},
			async getmsginfo() {
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/dispatchTruckinfoById",
        "post",
        {
          id: this.$route.params.id,
        }
      );
      if (data.code != 0) return console.log("获取详情数据失败");
      this.planEntity=data.planEntity;
      this.dispatchTruck=data.dispatchTruck;
      this.carEntity=data.carEntity;
    },
		}
	}
</script>

<style lang="scss" scoped>
	.taskstatus {
		height: 100%;
		width: 100%;

			.electronic {
				position: relative;
				width: 100%;
				height: 100%;

				.title_txt {
					position: absolute;
					top: 4%;
					width: 100%;
					font-size: 120%;
					text-align: center;
					z-index: 999;
					font-weight: bold;
				}

				.backimg {
					position: absolute;
					top: 0;
					left: 0;
					height: 100%;
					width: 100%;
				}

				.table {
					display: table;
					width: 100%;
					height: 100%;
					border-collapse: collapse;

					.table_row {
						position: relative;
						display: table-row;
						width: 100%;

						.table_td {
							position: relative;
							display: table-cell;
							vertical-align: middle;
							padding: 0 10px;
							border-left: none;
							border-top: none;
							width: 50%;

							.txt {
								position: absolute;
								color: #2797f5;
								white-space: nowrap;
							}
						}
					}
				}

				.box1 {
					position: absolute;
					top: 9%;
					height: 30%;
					left: 10px;
					right: 10px;
					border-bottom: 1px solid #ddd8cc;
					overflow: hidden;
				}

				.box2 {
					position: absolute;
					top: 39%;
					height: 20%;
					left: 10px;
					right: 10px;
					border-bottom: 1px solid #ddd8cc;
				}

				.box3 {
					position: absolute;
					top: 59%;
					bottom: 0;
					left: 10px;
					right: 10px;

					.table {
						height: 45%;
					}

					.code_img {
						position: relative;
						height: 55%;

						.line_code {
							position: absolute;
							z-index: 999;
							left: 50%;
							top: 0px;
							transform: translateX(-50%);
						}
					}
				}

				.last_txt {
					position: absolute;
					bottom: 1%;
					left: 10px;
					color: #1A91F4;
					margin-left: 10px;
				}
			}
	}
</style>
